import { BarChartDataItem } from "./BarChartDataItem";

export class BarChartData<T> {
    constructor(public barChartDataItems: BarChartDataItem<T>[]) {}
}
